export const SEARCH_EXPERIMENT = 'gp_signup_new_search_api_v2';
export const SEARCH_UI_EXPERIMENT = 'gp_signup_new_search_ui_v2';